import {
  SalesOrganizationsQuery,
  useSalesOrganizationsQuery
} from "@saleor/graphql";
import { FormikProps, useFormik } from "formik";
import React, { useCallback, useMemo, useState } from "react";
import * as Yup from "yup";

import { ALT_MATERIAL_TYPE } from "./AddItem";

const validationSchema = Yup.object().shape({
  saleOrganization: Yup.string().required("โปรดระบุข้อมูล"),
  soldTo: Yup.string().required("โปรดระบุข้อมูล"),
  type: Yup.string().required("โปรดระบุข้อมูล Type"),
  materialOwn: Yup.string().required("โปรดระบุข้อมูล")
});
interface FormikValueInit {
  saleOrganization: string;
  soldTo: string;
  type: string;
  materialOwn: string;
  priority: any[];
}

const AddAlternatedContext = React.createContext<{
  isSubmitted: boolean;
  formik: FormikProps<FormikValueInit>;
  handleOpenPopup: () => void;
  handleClosePopup: () => void;
  openConfirmPopup: boolean;
  listOrganization: SalesOrganizationsQuery;
  setMaterialOwnIdError: React.Dispatch<React.SetStateAction<string>>;
  materialOwnIdError: string;
  onAddAlterrmatedMaterial?(props?: any);
}>(undefined);

export const AddAlternatedProvider: React.FC = ({ children }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [materialOwnIdError, setMaterialOwnIdError] = useState("");

  const formik = useFormik({
    initialValues: {
      saleOrganization: "",
      soldTo: "",
      type: "",
      materialOwn: "",
      priority: []
    },
    enableReinitialize: false,
    validateOnChange: isSubmitted,
    validateOnBlur: false,
    onSubmit(values) {
      const { priority } = values;
      const hasNoValue = priority.filter(p => {
        if (Object.values(p).filter(e => !e).length > 0) {
          return true;
        }
        return false;
      });
      if (hasNoValue.length) {
        return;
      }
    },
    validationSchema
  });

  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);

  const handleOpenPopup = useCallback(() => {
    setIsSubmitted(true);

    formik
      .validateForm()
      .then(() => new Promise(resolve => setTimeout(resolve, 0)))
      .then(() => {
        formik.setSubmitting(false);

        if (
          formik.isValid &&
          formik.values.materialOwn &&
          formik.values.priority.length &&
          formik.values.priority?.every(e => e.materialOsId) &&
          formik.values.saleOrganization &&
          !materialOwnIdError &&
          formik.values.soldTo
        ) {
          if (
            formik.values.type !== ALT_MATERIAL_TYPE.GRADE_GRAM ||
            (formik.values.type === ALT_MATERIAL_TYPE.GRADE_GRAM &&
              formik.values.priority.every(item => item?.dia))
          ) {
            setOpenConfirmPopup(true);
          }
        } else {
          setOpenConfirmPopup(false);
        }
      })
      .catch(error => {
        console.error("An error occurred during form validation:", error);
      });
  }, [formik, materialOwnIdError, setIsSubmitted, setOpenConfirmPopup]);

  const handleClosePopup = useCallback(() => {
    setOpenConfirmPopup(false);
  }, []);

  const { data: listOrganization } = useSalesOrganizationsQuery();

  const memoizedValue = useMemo(
    () => ({
      formik,
      handleOpenPopup,
      handleClosePopup,
      openConfirmPopup,
      listOrganization,
      setMaterialOwnIdError,
      materialOwnIdError,
      isSubmitted
    }),
    [
      formik,
      handleOpenPopup,
      handleClosePopup,
      openConfirmPopup,
      listOrganization,
      setMaterialOwnIdError,
      materialOwnIdError,
      isSubmitted
    ]
  );

  return (
    <AddAlternatedContext.Provider value={memoizedValue}>
      {children}
    </AddAlternatedContext.Provider>
  );
};

export const useAddAltermatedMaterial = () => {
  const {
    formik,
    handleOpenPopup,
    handleClosePopup,
    openConfirmPopup,
    listOrganization,
    setMaterialOwnIdError,
    materialOwnIdError,
    isSubmitted
  } = React.useContext(AddAlternatedContext);
  return useMemo(
    () => ({
      formik,
      handleOpenPopup,
      handleClosePopup,
      openConfirmPopup,
      listOrganization,
      setMaterialOwnIdError,
      materialOwnIdError,
      isSubmitted
    }),
    [
      formik,
      handleOpenPopup,
      handleClosePopup,
      openConfirmPopup,
      listOrganization,
      setMaterialOwnIdError,
      materialOwnIdError
    ]
  );
};
